
// ...existing code...
// Cambia esta constante para elegir el modo del menú en desktop:
// 'compact' = enlaces más pequeños, 'wrap' = dos filas si no caben
import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Logout from '../components/Logout';
import { useAuthStore } from '../store/authStore';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageDropdown from '../components/LanguageDropdown';
import uniLogo from '../images/uniempleo-logo-nuevo.png';
import unicaribeLogo from '../images/logo-UNICARIBE-2.png';
import bnr3 from '../images/background/bg3.jpg';

export const SHOW_DEFAULT_NAVIGATION = false; // true = mostrar links de documentacion, false = mostrar links reales
const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';

// Definir los enlaces del navbar como un arreglo de objetos
const NAV_LINKS = [
	{ path: '/', label: 'header.home', exact: true },
	{ path: '/about-us', label: 'header.whoWeAre' },
	{ path: '/students-and-graduates', label: 'header.studentsAndGraduates' },
	{ path: '/career-counseling', label: 'header.careerCounseling' },
	{ path: '/browse-job-filter-grid', label: 'header.searchVacancy' },
	{ path: '/contact', label: 'contact.title' },
];

export function Header() {
	const [show, setShow] = useState(false);
	const { isAuthenticated, auth } = useAuthStore();
	const { t, language } = useLanguage();
	const authenticated = isAuthenticated();
	const userRole = auth?.user?.tipoPerfil;
	const profilePath = userRole === 'EMPRESA' ? '/company-profile' : '/profile';

	const handleClose = () => setShow(false);
	// const handleShow = () => setShow(true);

    

	useEffect(() => {
		// sidebar open/close - Mejorado para evitar conflictos
		var Navicon = document.querySelector('.navicon');
		var sidebarmenu = document.querySelector('.myNavbar');

		const toggleFunc = (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (sidebarmenu) {
				sidebarmenu.classList.toggle('show');
			}
		};

		if (Navicon && sidebarmenu) {
			Navicon.removeEventListener('click', toggleFunc);
			Navicon.addEventListener('click', toggleFunc);
		}

		// Agregar estilos CSS dinámicos para móviles
		const style = document.createElement('style');
		style.id = 'header-mobile-styles';
		style.textContent = `
            /* Estilos para los botones dentro del navbar */
            .header-nav .nav.navbar-nav > li > .site-button {
                display: inline-block;
                padding: 10px 20px;
                margin: 5px;
                border-radius: 4px;
                font-weight: 500;
                text-align: center;
                white-space: nowrap;
                vertical-align: middle;
                cursor: pointer;
                border: 1px solid transparent;
                transition: all 0.3s ease;
            }

			.active-nav-link {
				color: #00004c !important;
			}
            
            .header-nav .nav.navbar-nav > li > .site-button:hover {
                opacity: 0.9;
                transform: translateY(-1px);
            }

            @media only screen and (max-width: 991px) {
                .header-nav.navbar-collapse .nav.navbar-nav {
                    flex-direction: column !important;
                    width: 100% !important;
                    align-items: stretch !important;
                }
                .header-nav.navbar-collapse .nav.navbar-nav > li {
                    width: 100% !important;
                    display: block !important;
                    float: none !important;
                    white-space: normal !important;
                }
                .header-nav.navbar-collapse .nav.navbar-nav > li > a {
                    display: block !important;
                    width: 100% !important;
                    border-bottom: 1px solid #e9ecef !important;
                    padding: 12px 15px !important;
                    text-align: left !important;
                }
                .header-nav.navbar-collapse .nav.navbar-nav > li > a:hover {
                    background-color: #f8f9fa !important;
                }
                
                /* Mantener estilos de botones en móvil */
                .header-nav.navbar-collapse .nav.navbar-nav > li > .site-button {
                    display: block !important;
                    width: calc(100% - 30px) !important;
                    margin: 10px 15px !important;
                }
            }
            @media only screen and (max-width: 767px) {
                .logo-header.mostion {
                    max-width: 180px !important;
                    gap: 8px !important;
                    padding-right: 10px !important;
                }
                .logo-header.mostion .logo {
                    max-width: 100px !important;
                }
                .logo-header.mostion img[alt="UNICARIBE"] {
                    height: 35px !important;
                }
            }
            @media only screen and (max-width: 480px) {
                .logo-header.mostion {
                    max-width: 150px !important;
                    gap: 6px !important;
                    padding-right: 10px !important;
                }
                .logo-header.mostion .logo {
                    max-width: 80px !important;
                }
                .logo-header.mostion img[alt="UNICARIBE"] {
                    height: 30px !important;
                }
            }
        `;
		document.head.appendChild(style);

		// Sidenav li open close
		var navUl = [].slice.call(document.querySelectorAll('.navbar-nav > li > a, .sub-menu > li > a'));

		const checkLi = function () {
			this.parentElement.parentElement.querySelectorAll("li").forEach(el =>
				(this.parentElement !== el) ? el.classList.remove('open') : ''
			);
			setTimeout(() => {
				if (this.parentElement) {
					this.parentElement.classList.toggle('open');
				}
			}, 100);
		};

		for (var y = 0; y < navUl.length; y++) {
			navUl[y].addEventListener('click', checkLi);
		}

		// Cleanup function
		return () => {
			if (Navicon) {
				Navicon.removeEventListener('click', toggleFunc);
			}
			const styleElement = document.getElementById('header-mobile-styles');
			if (styleElement) {
				document.head.removeChild(styleElement);
			}
			for (var y = 0; y < navUl.length; y++) {
				navUl[y].removeEventListener('click', checkLi);
			}
		};
	}, []);

	return (
		<>
			<header className="site-header mo-left header fullwidth">
				<div className="sticky-header main-bar-wraper navbar-expand-lg">
					<div className="main-bar clearfix" style={{ display: 'flex', alignItems: 'center' }}>
						<div className="container-fluid clearfix" style={{ paddingLeft: '15px', paddingRight: '15px', maxWidth: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'nowrap' }}>
							<div className="logo-header mostion" style={{ display: 'flex', alignItems: 'center', gap: '10px', width: 'auto', maxWidth: '300px', flexShrink: 0, paddingRight: '15px', overflow: 'hidden' }}>

								<a href="https://unicaribe.edu.do/" className="dez-page" target="_blank" rel="noopener noreferrer" style={{ flexShrink: 0, display: 'block' }}>
									<img
										src={unicaribeLogo}
										alt="UNICARIBE"
										style={{ maxHeight: '55px', height: 'auto', width: 'auto', flexShrink: 0 }}
									/>
								</a>

								<Link to={"/"} style={{ flexShrink: 0, display: 'block', maxWidth: '100%', overflow: 'hidden' }}>
									<img
										src={uniLogo}
										className="logo"
										alt="UNIEMPLEO"
										style={{ maxWidth: '120px', height: 'auto', width: 'auto' }}
									/>
								</Link>
							</div>

							<button
								className="navbar-toggler collapsed navicon justify-content-end"
								type="button"
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									const menu = document.querySelector('.myNavbar');
									if (menu) {
										menu.classList.toggle('show');
									}
								}}
								style={{ zIndex: 1001 }}
								aria-controls="navbarNavDropdown"
								aria-expanded="false"
								aria-label="Toggle navigation"
							>
								<span></span>
								<span></span>
								<span></span>
							</button>


							<div className="header-nav navbar-collapse collapse myNavbar justify-content-start" id="navbarNavDropdown"
								style={{ flexGrow: 1, minWidth: 0, display: 'flex', flexWrap: 'nowrap', overflow: 'hidden', flexDirection: 'column' }}>
								{/* Logo centrado arriba para móviles */}
								<div className="logo-header mostion d-md-block d-lg-none" style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									gap: '15px',
									padding: '20px 15px',
									width: '100%',
									textAlign: 'center',
									borderBottom: '1px solid #e9ecef',
									backgroundColor: '#fff'
								}}>
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px', width: '100%', flexWrap: 'wrap' }}>
										<Link to={'/'} className="dez-page" style={{ display: 'block' }}>
											<img
												src={uniLogo}
												alt="UNIEMPLEO"
												style={{ maxWidth: '150px', height: 'auto', margin: '0 auto' }}
											/>
										</Link>
										<a href="https://unicaribe.edu.do/" className="dez-page" target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
											<img
												src={unicaribeLogo}
												alt="UNICARIBE"
												style={{ maxHeight: '55px', height: 'auto', width: 'auto', flexShrink: 0 }}
											/>
										</a>
									</div>
								</div>

								{/* Menu de navegación */}

								<ul
									className="nav navbar-nav"
									style={{
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										paddingInline: '0',
										width: '100%',
										flexWrap: 'wrap',
										whiteSpace: 'normal',
										overflowX: 'visible',
										fontSize: '0.80rem',
									}}
								>
									{NAV_LINKS.filter(link => link.path !== '/browse-job-filter-grid' || !DEMO_MODE).map(link => (
										<li key={link.path} style={{ whiteSpace: 'nowrap' }}>
											<NavLink
												to={link.path}
												exact={!!link.exact}
												className="dez-page"
												activeClassName="active-nav-link"
												style={{ padding: '4px 7px', fontSize: '0.80rem' }}
											>
												{t(link.label)}
											</NavLink>
										</li>
									))}

									{/* Language dropdown */}
									<li style={{ whiteSpace: 'nowrap' }}>
										<LanguageDropdown />
									</li>

									{/* Enlaces de autenticación */}
									{
										authenticated ? (
											<>
												<li style={{ whiteSpace: 'nowrap' }}>
													<Link to={profilePath} className="site-button"
														style={{ backgroundColor: '#009247', borderColor: '#009247', color: 'white' }}>
														<i className="fa fa-user"></i> {t('header.profile')}
													</Link>
												</li>
												<li style={{ whiteSpace: 'nowrap' }}>
													<Logout />
												</li>
											</>
										) : (
											<>
												<li style={{ whiteSpace: 'nowrap' }}>
													<Link to={"/login"} className="site-button " style={{ color: 'white' }}>
														<i className="fa fa-lock"></i> {t('header.login')}
													</Link>
												</li>
												<li style={{ whiteSpace: 'nowrap' }}>
													<Link to={"/register"} className="site-button" style={{ backgroundColor: '#009247', borderColor: '#009247', color: 'white' }}>
														<i className="fa fa-user-plus"></i> {t('header.register')}
													</Link>
												</li>
											</>
										)
									}

								</ul>
							</div>
							<div className="extra-nav" style={{ flexShrink: 0, paddingLeft: '15px', display: 'none' }}>
								<div className="extra-cell" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
									{/* Vacío - Los botones ahora están en el UL */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>

			{/* Model Start */}

			<Modal className=" lead-form-modal" show={show} onHide={handleClose} centered >
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<button type="button" className="close" onClick={handleClose}>
							<span aria-hidden="true">&times;</span>
						</button>
						<div className="modal-body row m-a0 clearfix">
							<div className="col-lg-6 col-md-6 overlay-primary-dark d-flex p-a0" style={{ backgroundImage: "url(" + bnr3 + ")", backgroundPosition: "center", backgroundSize: "cover" }}>
								<div className="form-info text-white align-self-center">
									<h3 className="m-b15">Login To You Now</h3>
									<p className="m-b15">Lorem Ipsum is simply dummy text of the printing and typesetting industry has been the industry.</p>
									<ul className="list-inline m-a0">
										<li><Link to={"#"} className="m-r10 text-white"><i className="fa fa-facebook"></i></Link></li>
										<li><Link to={"#"} className="m-r10 text-white"><i className="fa fa-google-plus"></i></Link></li>
										<li><Link to={"#"} className="m-r10 text-white"><i className="fa fa-linkedin"></i></Link></li>
										<li><Link to={"#"} className="m-r10 text-white"><i className="fa fa-instagram"></i></Link></li>
										<li><Link to={"#"} className="m-r10 text-white"><i className="fa fa-twitter"></i></Link></li>
									</ul>
								</div>
							</div>
							<div className="col-lg-6 col-md-6 p-a0">
								<div className="lead-form browse-job text-left">
									<form>
										<h3 className="m-t0">Personal Details</h3>
										<div className="form-group">
											<input className="form-control" placeholder="Name" />
										</div>
										<div className="form-group">
											<input className="form-control" placeholder="Mobile Number" />
										</div>
										<div className="clearfix">
											<button type="button" className="btn-primary site-button btn-block">Submit </button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal>
			{/*  Model END */}
		</>
	)
}